<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, BLOCK } from '#library/components.schema.build.ts'
	import Render from '#components/render.svelte'

	interface Props {
		blok: Blok<BLOCK>
	}

	let { blok }: Props = $props()
</script>

<section class="details {blok.theme}" {...attrs(blok)}>
	<div class="contain">
		<div class="title">{blok.title}</div>
		<div class="items">
			{#each blok.items as item, i (i)}
				<div class="item">
					<div class="subtitle">{item.title}</div>
					<div class="body">
						<Render content={item.body} />
					</div>
				</div>
			{/each}
		</div>
	</div>
</section>

<style lang="css">
	.details {
		background-color: var(--c-background);
		color: var(--c-midground);
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
	}

	.title {
		font: 600 var(--f-h3);
		letter-spacing: var(--ls-h3);
		margin-block-end: 2rem;
	}

	.items {
		display: grid;
		gap: 1.5rem;

		@media (--from-tablet) {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
	}

	.subtitle {
		font: 600 var(--f-h6);
		letter-spacing: var(--ls-h6);
	}

	.body {
		font: 400 var(--f-body1);
		letter-spacing: var(--ls-body1);

		:global(a) {
			color: var(--c-foreground);
			font-weight: 600;
		}
	}
</style>
